import { cva } from 'class-variance-authority';

export const cvaRoot = cva(
  [
    'TogglerBadgeStyles-cvaRoot',
    'inline-block',
    'relative',
    'py-0.4 px-0.6 pl-2 sm:pl-2.4',
    'text-labelM text-cWhite font-semibold uppercase',
    'rounded-[0.8rem]',
  ],
  {
    variants: {
      type: {
        new: ['bg-cMediumGreen'],
        sale: ['bg-cExtraOrange'],
        hit: ['bg-[#6CBCF7]'],
        '1+1': ['bg-[#A065FE]'],
      },
    },
    defaultVariants: {
      type: 'new',
    },
  }
);

export const cvaIcon = cva([
  'TogglerBadgeStyles-cvaIcon',
  'absolute left-0.4 top-0.4',
  'w-1.2 sm:w-1.6 h-1.2 sm:h-1.6',
]);
